<template>
  <layout>
    <div id="company-page">
      <!-- Header -->
      <header
        class="header text-center h-fullscreen text-lg-left pb-0 bg-size-contain bg-img-right overflow-hidden"
        :style="{'background-image': `url(${require('../assets/landings/bg/bg-header-effects.png')})`}"
      >
        <div class="container">
          <div class="row h-100">
            <div class="col-lg-6 align-self-center pb-lg-4">
              <h1 class="font-weight-bold">
                Software para processos seletivos inteligentes
              </h1>
              <p
                class="lead mt-3 mb-6"
                style="color: #6479ec;"
              >
                Automação para simplificar o processo de recrutamento e seleção e inteligência para acertar na contratação de profissionais.
              </p>
              <p class="gap-xy">
                <a
                  class="btn btn-round btn-lg btn-primary bg-color-primary b-0 mw-150"
                  href="#form"
                  target="_bank"
                >QUERO UMA DEMONSTRAÇÃO</a>
                <a
                  class="btn btn-round btn-lg btn-outline-secondary mw-150"
                  :href="`${protocol}candidatos.${currentdomain}`"
                >QUERO EMPREGO</a>
              </p>
            </div>

            <div class="col-lg-6 ml-auto align-self-end image">
              <img
                class="mt-6 img-fluid lazy-image"
                src="../assets/landings/preview/img-header3.png"
                alt="img"
              >
            </div>
          </div>
        </div>
      </header><!-- /.header -->

      <!-- Main Content -->
      <main class="main-content">
        <!--
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          | Features
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          !-->
        <section
          class="section pt-0"
          style="margin-top: -30px"
        >
          <div
            class="card shadow rounded py-8 px-7 container"
            style="border-radius: 1.5rem !important;"
          >
            <header class="section-header">
              <h2>Desburocratize com o Abler </h2>
              <hr>
              <p class="lead">
                Nosso software inteligente é para empresas e consultorias de RH que desejam fazer contratações mais assertivas em menos tempo para seus clientes.
              </p>
            </header>

            <div class="row gap-y text-center-xs">
              <div class="col-md-6 col-xl-4 feature">
                <!-- <p class="feature-icon text-primary"><i class="icon-mobile"></i></p> -->
                <p class="feature-icon text-primary">
                  <img
                    style="height: 90px"
                    src="../assets/landings/icon/company-icon1.svg"
                    alt="icon-1"
                  >
                </p>
                <h5>Centralize vagas</h5>
                <p>Abra vagas no Abler e as tenha publicadas em portais como Indeed, Jooble e Google, e a gestão dos processos seletivos em um único lugar.</p>
              </div>

              <div class="col-md-6 col-xl-4 feature">
                <!-- <p class="feature-icon"><i class="icon-gears"></i></p> -->
                <p class="feature-icon text-primary">
                  <img
                    style="height: 90px"
                    src="../assets/landings/icon/company-icon2.svg"
                    alt="icon-2"
                  >
                </p>
                <h5>Triagem automática</h5>
                <p>O sistema faz a triagem dentro do nosso Marketplace, cruzando as necessidades apontadas na vaga com as competências dos candidatos.</p>
              </div>

              <div class="col-md-6 col-xl-4 feature">
                <!-- <p class="feature-icon text-info"><i class="icon-tools"></i></p> -->
                <p class="feature-icon text-primary">
                  <img
                    style="height: 90px"
                    src="../assets/landings/icon/company-icon3.svg"
                    alt="icon-3"
                  >
                </p>
                <h5>Gestão fácil</h5>
                <p>Os recrutadores da empresa podem gerenciar todos os processos seletivos de maneira intuitiva e prática no nosso painel.</p>
              </div>

              <div class="col-md-6 col-xl-4 feature">
                <!-- <p class="feature-icon text-warning"><i class="icon-layers"></i></p> -->
                <p class="feature-icon text-primary">
                  <img
                    style="height: 90px"
                    src="../assets/landings/icon/company-icon4.svg"
                    alt="icon-4"
                  >
                </p>
                <h5>Simplifique etapas</h5>
                <p>Com o Pipeline do processo é muito prático organizar as etapas desde a qualificação do candidato até a contratação.</p>
              </div>

              <div class="col-md-6 col-xl-4 feature">
                <!-- <p class="feature-icon text-danger"><i class="icon-recycle"></i></p> -->
                <p class="feature-icon text-primary">
                  <img
                    style="height: 90px"
                    src="../assets/landings/icon/company-icon5.svg"
                    alt="icon-5"
                  >
                </p>
                <h5>Controle total</h5>
                <p>Tenha relatórios completos das candidaturas das vagas, controle as informações para saber o andamento do processo seletivo.</p>
              </div>

              <div class="col-md-6 col-xl-4 feature">
                <!-- <p class="feature-icon text-success"><i class="icon-chat"></i></p> -->
                <p class="feature-icon text-primary">
                  <img
                    style="height: 90px"
                    src="../assets/landings/icon/company-icon6.svg"
                    alt="icon-6"
                  >
                </p>
                <h5>Contrate ou desclassifique</h5>
                <p>Envie propostas aos aprovados e para os que não atendem no momento envie Feedbacks automáticos.</p>
              </div>
            </div>
          </div>
        </section>

        <!--
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          | CTA
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          !-->
        <section class="section text-center pt-3">
          <div class="container">
            <h2 class="mb-6">
              <strong>Descubra o Abler</strong>
            </h2>
            <p class="lead text-muted mb-6 px-lg-10">
              Encontrar o profissional certo não é uma tarefa simples, mas com o Abler é possível otimizar o processo seletivo, ter mais assertividade na contratação e centralizar tudo em uma única plataforma.
            </p>
            <a
              class="btn btn-lg btn-round btn-primary bg-color-primary b-0 py-4 px-7"
              href="#form"
              target="_bank"
            >Agende uma demonstração</a>
          </div>
        </section>

        <!--
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          | Benefits
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          !-->
        <section
          id="section-benefits"
          class="section text-white overflow-hidden bg-brand-dark"
        >
          <div class="container-fluid pr-lg-0">
            <div class="row gap-y align-items-center">
              <div class="col-md-4 mx-auto">
                <h2>Recrute e selecione de forma ágil e organizada</h2>
                <p>Com o nosso software de recrutamento e seleção é possível otimizar as etapas burocráticas e através da nossa inteligência cruzar informações para promover o Match entre candidatos e empresas impactando no aumento de assertividade nas contratações.</p>

                <hr class="w-50px ml-0">

                <div class="row">
                  <div class="col-6">
                    <p class="lead-5">
                      <i class="ti-user" />
                    </p>
                    <p class="text-uppercase fw-600 mb-0">
                      Banco de talentos
                    </p>
                    <p>São mais de 150 mil talentos cadastrados e disponíveis no mercado em busca de oportunidades no mercado.</p>
                  </div>

                  <div class="col-6">
                    <p class="lead-5">
                      <i class="fa fa-hand-o-up" />
                    </p>
                    <p class="text-uppercase fw-600 mb-0">
                      Os melhores
                    </p>
                    <p>O ranking dos melhores candidatos automático para analisar os currículos e perfis mais aderentes as vagas.</p>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mt-7 mt-md-0 comp-crop">
                <img
                  src="../assets/landings/preview/notebook-pipeline.png"
                  class="w-100"
                  alt="..."
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
              </div>
            </div>
          </div>
        </section>

        <!--
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          | Metrics
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          !-->
        <section class="section">
          <div class="container">
            <div class="row gap-y">
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-md-4 col-lg-4 my-2">
                    <a
                      class="card text-white text-center bg-img py-6 rounded-0"
                      href="#"
                      style="min-height: 153px; opacity: 0.6; background: #803BFF; background-repeat: no-repeat; background-position: left bottom; background-size: contain;"
                      :style="{'background-image': `url(${require('../assets/landings/bg/bg-img-effect-1.png')})`}"
                    >
                      <div class="position-relative">
                        <h2 class="mb-0 font-weight-bold">+4000</h2>
                        <p
                          class="small m-0"
                          style="line-height: 1.2rem;"
                        >VAGAS ABERTAS</p>
                      </div>
                    </a>
                  </div>

                  <div class="col-md-4 col-lg-4 my-2">
                    <a
                      class="card text-white text-center bg-img py-6 rounded-0"
                      href="#"
                      style="min-height: 153px; opacity: 0.6; background: #00CD8C;"
                    >
                      <div class="position-relative">
                        <h2 class="mb-0 font-weight-bold">+500</h2>
                        <p
                          class="small m-0"
                          style="line-height: 1.2rem;"
                        >PROCESSOS EM ANDAMENTO</p>
                      </div>
                    </a>
                  </div>

                  <div class="col-md-4 col-lg-4 my-2">
                    <a
                      class="card text-white text-center bg-img py-6 rounded-0"
                      href="#"
                      style="min-height: 153px; opacity: 0.6; background: #0081FF; background-repeat: no-repeat; background-position: right top; background-size: contain;"
                      :style="{'background-image': `url(${require('../assets/landings/bg/bg-img-effect-2.png')})`}"
                    >
                      <div class="position-relative">
                        <h2 class="mb-0 font-weight-bold">+2000</h2>
                        <p
                          class="small m-0"
                          style="line-height: 1.2rem;"
                        >VAGAS FECHADAS</p>
                      </div>
                    </a>
                  </div>

                  <div class="col-md-4 col-lg-4 my-2">
                    <a
                      class="card text-white text-center bg-img py-6 rounded-0"
                      href="#"
                      style="min-height: 153px; opacity: 0.6; background: #EC4A2B;"
                    >
                      <div class="position-relative">
                        <h2 class="mb-0 font-weight-bold">+150 mil</h2>
                        <p
                          class="small m-0"
                          style="line-height: 1.2rem;"
                        >CANDIDATOS CADASTRADOS</p>
                      </div>
                    </a>
                  </div>

                  <div class="col-md-4 col-lg-4 my-2">
                    <a
                      class="card text-white text-center bg-img py-6 rounded-0"
                      href="#"
                      style="min-height: 153px; opacity: 0.6; background: #FF8855; background-repeat: no-repeat; background-position: bottom right; background-size: contain;"
                      :style="{'background-image': `url(${require('../assets/landings/bg/bg-img-effect-3.png')})`}"
                    >
                      <div class="position-relative">
                        <h2 class="mb-0 font-weight-bold">+80</h2>
                        <p
                          class="small m-0"
                          style="line-height: 1.2rem;"
                        >EMPRESAS<br>ATENDIDAS</p>
                      </div>
                    </a>
                  </div>

                  <div class="col-md-4 col-lg-4 my-2">
                    <a
                      class="card text-white text-center bg-img py-6 rounded-0"
                      href="#"
                      style="min-height: 153px; opacity: 0.6; background: #FFA61E"
                    >
                      <div class="position-relative">
                        <h2 class="mb-0 font-weight-bold">6 dias</h2>
                        <p
                          class="small m-0"
                          style="line-height: 1.2rem;"
                        >FECHAMENTO MÉDIO<br>DAS VAGAS</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 align-self-center pb-lg-4">
                <h2 class="font-weight-bold">
                  Tenha contratações inteligentes
                </h2>
                <p class="lead mt-3 mb-0">
                  Este é o momento de desburocratizar processos e investir energia na gestão de pessoas. Processos ágeis e resultados inteligentes, este é o nosso propósito
                </p>
              </div>
            </div>
          </div>
        </section>

        <!--
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          | Integrations
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          !-->
        <section
          id="section-integrations"
          class="section py-7 bg-brand-dark"
        >
          <div class="container">
            <div class="row gap-y align-items-center">
              <div class="col">
                <h4 class="mb-0 text-white text-center text-md-left">
                  Publicamos suas vagas nos principais portais do Brasil
                </h4>
              </div>

              <div class="partner partner-sm">
                <a
                  href="https://www.indeed.com.br/"
                  class="partner-link"
                  target="_blank"
                >
                  <img
                    src="../assets/landings/partner/logo-indeed.svg"
                    alt="logo Indeed"
                    class="animated fadeInUp delay-2s slow mx-5 my-0"
                  >
                </a>
                <a
                  href="https://br.jooble.org/"
                  class="partner-link"
                  target="_blank"
                  rel="dofollow"
                >
                  <img
                    src="../assets/landings/partner/logo-jooble.svg"
                    alt="logo Jooble"
                    class="animated fadeInUp delay-2s slow mx-5 my-0"
                    style="height: 40px"
                  >
                </a>
                <a
                  href="https://abler.in/google"
                  class="partner-link"
                  target="_blank"
                >
                  <img
                    src="../assets/landings/partner/logo-google.svg"
                    alt="logo Google"
                    class="animated fadeInUp delay-2s slow mx-5 my-0"
                  >
                </a>
              </div>
            </div>
          </div>
        </section>

        <!--
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          | Forms
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          !-->
        <section
          id="form"
          class="section bg-img py-7"
          :style="{'background-image': `url(${require('../assets/landings/bg/10.jpg')})`}"
          data-overlay="8"
        >
          <div class="container">
            <div class="row gap-y">
              <div class="col-11 col-md-5 mx-auto text-white pt-6">
                <h3 class="font-weight-bold mb-5">
                  SOLUÇÃO PARA EMPRESAS
                </h3><h4 class="font-weight-regular">
                  Se o seu negócio precisa otimizar os processo seletivos e fazer contratações com mais agilidade, preencha o formulário ao lado que nossos especialistas entrarão em contato com você.
                </h4>

                <div class="notification">
                  <h5>Procurando emprego?</h5>
                  <a
                    :href="`${protocol}candidatos.${currentdomain}`"
                    class="btn btn-primary bg-color-primary b-0 btn-round"
                  >Clique Aqui!</a>
                </div>
              </div>

              <div class="col-11 col-md-6 mx-auto mx-md-0">
                <form
                  class="row input-border"
                  @submit="formSubmit"
                >
                  <div class="col-md-10 mx-auto bg-white p-6 rounded">
                    <span v-if="success == true">
                      <img
                        src="../assets/landings/icon/icon-send-form.svg"
                        style="height: 203px;"
                        class="mx-auto d-block mb-5"
                      >
                      <h3 class="text-center font-weight-bold">Seu formulário foi enviado com sucesso!</h3>
                      <h5 class="text-center text-light font-weight-light">Muito obrigado por entrar em contato.</h5>
                    </span>
                    <span
                      v-if="success == false"
                      class="inputs-form"
                    >
                      <div
                        class="alert d-none"
                        :class="{'alert-success d-on-success d-block': success == true, 'alert-danger d-on-danger d-block': error == true,}"
                      >
                        {{ output }}
                      </div>
                      <div class="form-group">
                        <input
                          v-model="firstname"
                          class="form-control form-control-lg"
                          type="text"
                          name="firstname"
                          placeholder="Seu nome*"
                          required
                        >
                      </div>
                      <div
                        class="form-group"
                        :class="{'mb-0': isEmailValid()}"
                      >
                        <input
                          v-model="email"
                          class="form-control form-control-lg"
                          type="email"
                          name="email"
                          placeholder="Seu email empresarial*"
                          required
                        >
                        <small
                          v-if="isEmailValid()"
                          id="emailHelp"
                          class="form-text badge badge-pill badge-danger"
                        >Esse e-mail não é empresarial.</small>
                      </div>
                      <div class="form-group">
                        <input
                          v-model="company"
                          class="form-control form-control-lg"
                          type="text"
                          name="company"
                          placeholder="Nome da sua empresa*"
                          required
                        >
                      </div>
                      <div class="form-group">
                        <the-mask
                          v-model="phone"
                          class="form-control form-control-lg phone"
                          placeholder="Seu telefone para contato*"
                          name="phone"
                          :mask="['(##) ####-####', '(##) #####-####']"
                          required
                        />
                      </div>
                      <button
                        :disabled="!firstname || !email || !company || !phone || isEmailValid()"
                        class="btn btn-lg btn-block btn-round btn-primary bg-color-primary b-0"
                        type="submit"
                      >
                        Solicitar contato
                      </button>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <!--
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          | Testimonials
          |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
          !-->
        <section class="section overflow-hidden">
          <div class="container-fluid">
            <div class="row gap-y align-items-center">
              <div class="col-md-4 mx-auto">
                <h2>Quem usa, confia!</h2>
                <p class="lead">
                  Veja o que dizem alguns clientes felizes por acelerar suas contratações :)
                </p>

                <div
                  class="pb-7"
                  data-provide="slider"
                  data-autoplay="true"
                  data-slides-to-show="1"
                  data-dots="true"
                >
                  <!-- Testimony 1 -->
                  <div>
                    <div class="rating mb-2 mt-4">
                      <label class="fa fa-star" />
                      <label class="fa fa-star" />
                      <label class="fa fa-star" />
                      <label class="fa fa-star" />
                      <label class="fa fa-star" />
                    </div>
                    <p class="text-quoted">
                      A utilização do Abler ajudou muito na organização do nosso processo seletivo, nos
                      trouxe agilidade, dados precisos, otimização do tempo e isso tudo sempre com uma ajuda de suporte
                      incrível!
                    </p>
                    <div class="media align-items-center">
                      <div class="media-body lh-1">
                        <h6 class="mb-0">
                          Nadi Sterchille
                        </h6>
                        <small>@leadlovers</small>
                      </div>
                    </div>
                  </div>

                  <!-- Testimony 2 -->
                  <div>
                    <div class="rating mb-2 mt-4">
                      <label class="fa fa-star" />
                      <label class="fa fa-star" />
                      <label class="fa fa-star" />
                      <label class="fa fa-star" />
                      <label class="fa fa-star" />
                    </div>
                    <p class="text-quoted">
                      O Abler foi essencial para o desenvolvimento do modelo de recrutamento e seleção da Celero.
                    </p>
                    <div class="media align-items-center">
                      <div class="media-body lh-1">
                        <h6 class="mb-0">
                          João Augusto
                        </h6>
                        <small>@celero</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mt-7 mt-md-0">
                <img
                  src="../assets/landings/preview/notebook-process.png"
                  class="w-100"
                  alt="..."
                >
              </div>
            </div>
          </div>
        </section>
      </main><!-- /.Main Content -->
    </div>
  </layout>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VueTheMask from 'vue-the-mask';
import axios from 'axios';
import mixins from '../mixins/mixins';
import Layout from './shared/layout';

Vue.use(VueTheMask, axios);

export default {
  name: 'CompanyPage',

  // metaInfo: {
  //   title: this.current_title,
  //   meta: [
  //     {name: 'theme-color', content: '#6379EB'}
  //   ]
  // },

  components: {
    Layout,
    VueTheMask,
  },
  mixins: [mixins],
  props: {
    _current_user: {},
    _current_company: {},
    _current_admin: {},
    // current_title: ''
  },
  data() {
    return {
      // path current domain
      currentdomain: '',
      // path separate using split
      separate: window.location.host.split('.'),
      message: 'O Software de Recrutamento e Seleção',
      // Infos Form
      firstname: '',
      email: '',
      company: '',
      phone: '',
      output: '',
      success: '',
      error: '',
      email_valid: /^([\w-\.]+@(?!gmail+\.)(?!yahoo+\.)(?!hotmail+\.)(?!aol+\.)(?!abc+\.)(?!xyz+\.)(?!pqr+\.)(?!rediffmail+\.)(?!live+\.)(?!outlook+\.)(?!me+\.)(?!msn+\.)(?!ymail+\.)([\w-]+\.)+[\w-]{2,4})?$/,
    };
  },

  mounted() {
    // Actions remove subdomain
    // ==========================
    this.separate.shift();
    this.currentdomain = this.separate.join('.');
  },

  methods: {
    // Function split in cookie
    // ==========================
    getCookie(name) {
      // Split cookie string and get all individual name=value pairs in an array
      const cookieArr = document.cookie.split(';');

      // Loop through the array elements
      for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].split('=');

        /* Removing whitespace at the beginning of the cookie name
              and compare it with the given string */
        if (name == cookiePair[0].trim()) {
          // Decode the cookie value and return
          return decodeURIComponent(cookiePair[1]);
        }
      }

      // Return null if not found
      return null;
    },

    isEmailValid() {
      return (this.email == '') ? '' : !(this.email_valid.test(this.email));
    },

    // Send form Hubspot
    // ==========================
    formSubmit(e) {
      e.preventDefault();
      const currentObj = this;
      this.axios.post('https://api.hsforms.com/submissions/v3/integration/submit/5611593/a2efea77-c446-4430-9154-721aaad50c89', {
        fields: [
          {
            name: 'firstname',
            value: this.firstname,
          },
          {
            name: 'email',
            value: this.email,
          },
          {
            name: 'company',
            value: this.company,
          },
          {
            name: 'phone',
            value: this.phone,
          },
        ],
        context: {
          hutk: currentObj.getCookie('hubspotutk'),
          pageUri: 'empresas.abler.com.br',
          pageName: 'Abler Landing Page',
        },
      })
        .then((response) => {
          currentObj.output = response.data.inlineMessage;
          currentObj.success = true;
          currentObj.error = false;
        })
        .catch((error) => {
          // currentObj.output = error;
          currentObj.output = '😥 Ops! Algo está errado.';
          currentObj.error = true;
          currentObj.success = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  @use '../assets/stylesheet/variables.scss' as *;
  #company-page {
    header.header {
      background-color: #ffffff;

      h1.font-weight-bold {
        color: #6479ec;
        font-size: 2.4rem;
      }

      .title-header {
        font-size: 2.4rem;
        line-height: 1.4;

        @media screen and (max-width: 576px) {
          font-size: 1.8rem;
          line-height: 1.4;
        }
      }

      .title-header + p.lead {
        @media screen and (max-width: 576px) {
          font-size: 1.07rem;
        }
      }

      .mx-auto.w-80.img-header {
        @media screen and (max-width: 576px) {
          width: 70% !important;
          margin-top: 4rem !important;
        }
      }

      a.partner-link {
        img {
          transition: 0.5s;

          &:hover {
            margin-top: 14px !important;
            transition: 0.5s
          }
        }
      }
    }

    a.partner-link {
      img {
        transition: 0.5s;

        &:hover {
          margin-top: -18px !important;
          transition: 0.5s
        }
      }
    }

    #section-integrations {
      .partner {
        @media screen and (max-width: 576px) {
          width: 100%;
        }
      }
    }

    #section-benefits {
      .comp-crop {
        @media screen and (max-width: 576px) {
          padding-right: 0 !important;
        }
      }
    }
  }

  /**
  * MOBILE VERSION
  **/
  @media (max-width: 991.98px) {
    header {
      h1.font-weight-bold {
        font-size: 1.9rem !important;
      }

      p.lead.mt-3.mb-6 {
        font-size: 0.99rem;
      }
    }

    .card > a > .card-img-top {
      width: auto;
      max-width: 200%;
      height: auto;
      max-height: 200%;
      display: block;
      top: auto;
      left: auto;
      transition: 0.5s;
    }

    .text-center-xs {
      text-align: center;
    }

    #header-consulting .col-md-6,
    #header-companies .col-md-6 {
      position: relative;
      width: 100%;
      right: 0;
      flex: 0 0 100%;
      max-width: 100%;
      margin-top: 20px;
    }

    .section-product--services .nav .nav-item .card.nav-link {
      max-height: 124px;
      min-height: 124px;
      opacity: 0.6;
      padding: 0;
    }

    .section-product--services .nav .nav-item .card.nav-link.active {
      border: solid 5px;
    }

    .bg-size-contain {
        background-image: none !important;
    }
  }

  .bg-brand-dark {
    background-color: $abler_secondary;
  }

  #form .notification {
    background-color: $abler_secondary;
    padding: 15px;
    border-radius: 5px;
    text-align: center;
    margin-top: 18px;
  }
</style>
